import { useEffect, useRef, useState } from "react";
import { useBarragemContext, useUserContext } from "../../context";
import { Box, TextField } from "@mui/material";
import { RequestError, useApi } from "../../services";
import { ErrorOnDialog, LoadingModal } from "../modals";

export const PopulacaoZas: React.FC = () => {
  const api = useApi();
  const user = useUserContext();
  const { barragem, setBarragem } = useBarragemContext();

  const timer = useRef<NodeJS.Timer>();
  const [error, setError] = useState<RequestError>();
  const [urlPopZas, setUrlPopZas] = useState<string>();

  useEffect(() => {
    if (!barragem || "error" in barragem) return;
    setUrlPopZas(barragem.urlPopZas ?? "");
  }, [barragem]);

  const handleEditURL = (newUrl: string) => {
    if (!barragem || "error" in barragem) return;

    if (timer.current) clearTimeout(timer.current);
    timer.current = setTimeout(() => {
      api.barragem.updateUrlPopZas(barragem.id, newUrl).then((value) => {
        if ("error" in value) {
          setError(value);
          return;
        }
        setBarragem({
          ...barragem,
          urlPopZas: newUrl,
        });
      });
    }, 100);
  };


  if (urlPopZas === undefined) return <LoadingModal open={true} />;

  return <>
    {/* Error */}
    {error && <ErrorOnDialog
      open={Boolean(error)}
      error={error.error}
      message={error.message}
      onClose={() => setError(undefined)}
    />}

    <Box sx={{
      width: "100%",
      height: "100%",
      display: "flex",
      overflow: "auto",
      flexDirection: "column",
    }}>
      <iframe
        title="BI"
        width="100%"
        height="99%"
        src={urlPopZas}
        allowFullScreen={true}
      />

      {user && !("error" in user) && user.admin &&
        <>
          <div style={{ height: "1em" }} />
          <TextField fullWidth label="URL BI" variant="standard"
            value={urlPopZas}
            onChange={(ev) => {
              handleEditURL(ev.target.value);
              setUrlPopZas(ev.target.value);
            }}
          />
        </>
      }
    </Box>
  </>;
};
